<template>
    <div class="p-grid p-mx-auto p-text-center p-mt-1">
        <div class="p-col-3"></div>
        <div class="p-col-6 p-md-6 p-text-center">
        </div>
    </div>

    <div class="p-col-11 p-grid p-mx-auto p-mt-1">
        <div class="p-col-8 p-md-8 p-mx-auto">
            <h3>
                Live Events
                <Button icon="pi pi-refresh" @click="getLiveEvents()" class="p-button p-button-sm p-button-outlined"
                            :disabled="liveEvents.isLoading" style="float:right" />
            </h3>
            <div v-if="liveEvents.isLoading">
                Getting live events...
            </div>
            <div v-else-if="!liveEvents.isLoading && liveEvents.items !== undefined && liveEvents.items !== null && liveEvents.items.length > 0">
                <div v-for="(liveEvent, index) in liveEvents.items" :key="liveEvent.ssEventId">
                    <div class="p-grid p-mx-auto p-mt-2">
                        <div class="p-col-10 p-md-10 live-event">
                            <span class="status_tracking">{{liveEvent.time}}'</span>
                            <span v-if="liveEvent.injuryTime > 0">
                                + {{liveEvent.injuryTime}}
                            </span>
                            <span class="p-ml-2">{{liveEvent.mkHomeTeamName}}</span>
                            <span v-if="liveEvent.homeRedCard > 0">
                                <span class="p-ml-1" v-for="n in liveEvent.homeRedCard" :key="n">
                                    🟥
                                </span>
                            </span>
                            <span class="p-ml-2">{{liveEvent.homeScore}}
                            -
                            {{liveEvent.awayScore}}</span>
                            <span v-if="liveEvent.awayRedCard > 0">
                                <span class="p-ml-1" v-for="n in liveEvent.awayRedCard" :key="n">
                                    🟥
                                </span>
                            </span>
                            <span class="p-ml-2">{{liveEvent.mkAwayTeamName}}</span>
                        </div>
                        <div class="p-col-2 p-md-2">
                            <Button label="Remove" class="p-button-md p-button-outlined p-button-danger"
                                @click="removeLiveEvent(liveEvent.ssEventId, index)" />
                        </div>
                    </div>
                </div>
            </div>
            <p v-else-if="!liveEvents.isLoading">
                There is no live event is tracking by lmt-api.
            </p>
        </div>
    </div>

    <div class="p-col-11 p-grid p-mx-auto p-mt-6">
        <div class="p-col-8 p-md-8 p-mx-auto">
            <h3>
                Waitlist
                <Button icon="pi pi-refresh" @click="getWaitlist()" class="p-button p-button-sm p-button-outlined"
                            :disabled="waitlist.isLoading" style="float:right" />
            </h3>
            <div v-if="waitlist.isLoading">
                Getting waitlist events...
            </div>
            <div v-else-if="!waitlist.isLoading && waitlist.items !== undefined && waitlist.items !== null && waitlist.items.length > 0">
                <div v-for="(event, index) in waitlist.items" :key="event.ssEventId">
                    <div class="p-grid p-mx-auto p-mt-2">
                        <div class="p-col-10 p-md-10 p-text-left live-event">
                            <span>{{event.label}}</span>
                        </div>
                        <div class="p-col-2 p-md-2">
                            <Button label="Remove" class="p-button-md p-button-outlined p-button-danger"
                                @click="removeWaitlist(event.ssEventId, index)" />
                        </div>
                    </div>
                </div>
            </div>
            <p v-else-if="!waitlist.isLoading">
                There is no event in waitlist.
            </p>
        </div>
    </div>

</template>

<style>
div.live-event span {
    font-size: 1.3em;
}

.status_tracking {
    font-size: 1.5em;
    color: rgb(33, 222, 71);
}
.status_completed {
    color: rgb(135, 135, 135);
}
.event_ss_br_unmatched, .event_ss_mk_unmatched {
    color: rgb(238, 23, 23);
}
</style>

<script>
import axios from "axios";
import Button from "primevue/button";

let SpringApi;

export default {
    name: 'Trackable Events Schedule',
    components: {
        Button
    },
    emits: ["loginResult", "pageLoaded"],
    data() {
        return {
            liveEvents: {
                isLoading: false,
                items: [],
                selected: null,
            },
            waitlist: {
                isLoading: false,
                items: [],
                selected: null,
            }
        }
    },
    beforeMount() {
        SpringApi = axios.create({
            baseURL : process.env.VUE_APP_SPRING_API_URL,
            headers: {
                'Authorization': 'Bearer ' + this.$cookies.get('token')
            }
        });

        var page = {
            title: 'LMT Live Events'
        }
        this.$emit('pageLoaded', page)
    },
    async mounted() {
        await this.getLiveEvents()
        await this.getWaitlist()
    },
    methods: {
        async getLiveEvents() {
            this.liveEvents.isLoading = true

            try {
                let response = await SpringApi.get(`/lmt/live-events`);
                this.liveEvents.items = response.data
            } catch(error) {
                this.liveEvents.items = []
            }

            this.liveEvents.isLoading = false
        },
        removeLiveEvent(ssEventId, index) {
            this.$confirm.require({
                message: 'Remove live event from lmt-api?',
                header: 'Remove Live Event',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Remove',
                rejectLabel: 'Cancel',
                accept: async () => {
                    try {
                        await SpringApi.delete('/lmt/live-events?ssEventId='+ssEventId)
                        this.liveEvents.items.splice(index, 1);
                    } catch(error) {
                        console.log(error)
                    }
                },
                reject: () => {
                }
            })
        },
        async getWaitlist() {
            this.waitlist.isLoading = true

            try {
                let response = await SpringApi.get(`/lmt/waitlist`);
                this.waitlist.items = response.data

                if (this.waitlist.items !== undefined && this.waitlist.items !== null && this.waitlist.items.length > 0) {
                    let ssEventIdList = this.waitlist.items.map(item => item.ssEventId);
    
                    await this.getWaitlistEventLabels(ssEventIdList);
                }
            } catch(error) {
                console.log(error)
                this.waitlist.items = []
            }

            this.waitlist.isLoading = false
        },
        async getWaitlistEventLabels(ssEventIdList) {
            var ssEventIdListQueryParam = ssEventIdList.map(id => `ssEventId=${id}`).join('&');

            try {
                let response = await SpringApi.get(`/ssevents/labels?${ssEventIdListQueryParam}`);
                let labels = response.data.labels

                for (const ssEventId in labels) {
                    let waitlistEvent = this.waitlist.items.find(item => item.ssEventId == ssEventId);
                    if (waitlistEvent !== undefined && waitlistEvent !== null) {
                        waitlistEvent.label = labels[ssEventId];
                    }
                }

            } catch(error) {
                console.log(error)
            }
        },
        removeWaitlist(ssEventId, index) {
            this.$confirm.require({
                message: 'Remove waitlist event from lmt-api?',
                header: 'Remove Waitlist Event',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Remove',
                rejectLabel: 'Cancel',
                accept: async () => {
                    try {
                        await SpringApi.delete('/lmt/waitlist?ssEventId='+ssEventId)
                        this.waitlist.items.splice(index, 1);
                    } catch(error) {
                        console.log(error)
                    }
                },
                reject: () => {
                }
            })
        },
    }
}
</script>
